import styled from 'styled-components';
export const StepContainer = styled.div.withConfig({ displayName: "StepContainer", componentId: "sc-zkd9kg" }) `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;
export const StepContent = styled.div.withConfig({ displayName: "StepContent", componentId: "sc-ouek1w" }) `
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;
